import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react"

const initial = {
	searchQuery: ""
}

const patientsSlice = createSlice({
	name: "patients2", // TODO: WABA: Rename to patients once the old patients reducer is removed
	initialState: initial,
	reducers: {
		setSearchQuery: (state, action: PayloadAction<string>) => {
			state.searchQuery = action.payload
		}
	},
	selectors: {
		searchQuery: (slice) => slice.searchQuery
	}
})

export default patientsSlice
